export enum Routes {
    FORGOT_PASSWORD = '/forgot_password',
    CLIENTS_LIST = '/pos',
    CHANGE_PASSWORD = '/change_password',
    LOGIN = '/',
    CLIENT_PROFILE = '/client_profile',
    REVIEW_PAGE = '/reviews',
    SOCIAL_POST = '/posts',
    STATISTICHE = '/stats',
    GROUPS = '/groups',
    ADV = '/adv',
    GOOGLE_MY_BUSINESS = '/google-my-business',
    GOOGLE_CONNECTOR = '/google_connector',
    FACEBOOK_CONNECTOR = '/facebook_connector',
    GOOGLE_SYNC = '/google_sync',



}